import React from "react";
import useGameStore from "../store/gameStore";

const Score = React.memo(function Score() {
  const score = useGameStore((s) => s.score);

  return (
    <div
      className="score-area"
      style={{
        fontFamily: "Jua, sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <div
        className="score-label"
        style={{ fontSize: "24px", lineHeight: "10px" }}
      >
        score
      </div>
      <div
        className="score-value"
        style={{
          fontSize: "100px",
          lineHeight: "100px",
          minWidth: "80px",
        }}
      >
        {score}
      </div>
    </div>
  );
});

export default Score;
